import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const ACTIVE_AUTO_LABEL_LIBRARY_JOB_QUERY_KEY = 'taxonomy.activeAutoLabelLibraryJob';

export const useActiveAutoLabelLibraryJob = (taxonomyId: string | undefined) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading } = useQuery({
    queryKey: [ACTIVE_AUTO_LABEL_LIBRARY_JOB_QUERY_KEY, { tenantId, taxonomyId }],
    queryFn: () => api.taxonomy.getActiveAutoLabelLibraryJob(tenantId, taxonomyId ?? ''),
    enabled: Boolean(taxonomyId),
    refetchOnMount: 'always',
  });

  return {
    activeJob: data?.data.job,
    isLoading,
  };
};
